module.exports = {"TXTWCL_Deposit_Funds":{"id":"TXTWCL_Deposit_Funds","defaultMessage":"Indsæt penge","track":"Deposit Funds"}}